export default "__VITE_ASSET__CSLdSoWP__"